import React, { PropsWithChildren } from 'react';
import { BaseButton, Icon } from '@common/components';

export const ExportButton = ({
  onClick,
  loading,
  disabled,
  children,
}: PropsWithChildren<{
  onClick: () => void;
  loading: boolean;
  disabled?: boolean;
}>) => (
  <BaseButton
    icon={<Icon icon="fileExport" size="md" kind="light" />}
    onClick={onClick}
    loading={loading}
    disabled={disabled}
  >
    {children}
  </BaseButton>
);
